
import classNames from 'classnames';
import { parseAsStringEnum, useQueryState } from 'nuqs';

import type { RewardPoolTag } from '@shared/api/types/rewardPools';
import { REWARD_POOL_TAG } from '@shared/api/types/rewardPools';

export const REWARD_POOLS_CATEGORY_ALL_FILTER = 'ALL';

export type RewardPoolsCategoryFilterType = RewardPoolTag | typeof REWARD_POOLS_CATEGORY_ALL_FILTER;

export const DEFAULT_CATEGORY_FILTER_VALUE = REWARD_POOLS_CATEGORY_ALL_FILTER;

export const categoryFilterOptionsInOrder: {
  id: RewardPoolsCategoryFilterType;
  label: string;
}[] = [
  {
    id: REWARD_POOLS_CATEGORY_ALL_FILTER,
    label: 'All',
  },
  {
    id: REWARD_POOL_TAG.FEATURED,
    label: 'Featured',
  },
  {
    id: REWARD_POOL_TAG.LAST_CHANCE,
    label: 'Last Chance',
  },
  {
    id: REWARD_POOL_TAG.HOT,
    label: 'Hot',
  },
  {
    id: REWARD_POOL_TAG.HUGE_REWARD,
    label: 'Huge Reward',
  },
  {
    id: REWARD_POOL_TAG.TRENDING,
    label: 'Trending',
  },
];

export const useRewardPoolsCategoryFilterQueryState = () => {
  return useQueryState(
    'category',
    parseAsStringEnum<RewardPoolsCategoryFilterType>(
      categoryFilterOptionsInOrder.map(({ id }) => id),
    )
      .withDefault(REWARD_POOLS_CATEGORY_ALL_FILTER)
      .withOptions({ clearOnDefault: true }),
  );
};

export const CategoryFilter = () => {
  const [filter, setFilter] = useRewardPoolsCategoryFilterQueryState();

  return (
    <div className="toggle-button-group">
      {categoryFilterOptionsInOrder.map(({ id, label }) => {
        const isActive = filter === id;

        return (
          <button
            onClick={() => setFilter(id)}
            key={id}
            className={classNames('toggle-button', {
              'toggle-button-active': isActive,
            })}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};
